<template>
    <!-- <v-navigation-drawer permanent expand-on-hover app  dense>     -->
    <v-navigation-drawer app temporary dense disable-resize-watcher v-model="esVisible" color="claro">
    <!-- <v-navigation-drawer permanent app dense>     -->
        <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img src="../assets/venado-avatar.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>        
        </v-list>

        <v-list nav dense>
          <v-divider></v-divider>
          <v-list-item link to="/pspperfil">
            <v-list-item-icon>
              <v-icon color="green">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Perfil</v-list-item-title>
          </v-list-item>

          <v-list-item link to="/pspcontratos" >
            <v-list-item-icon>
              <v-icon color="green">mdi-file-document-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Contratos</v-list-item-title>
          </v-list-item>
        </v-list>
          
    </v-navigation-drawer>
</template>


<script>
export default {
    name: 'MenuLateralPSP',
    props:{
      value: Boolean
    },   
    data() {
        return {
            esVisible: this.value,
            
            nombre: "Fredy",
            apellido: "Ponce",
            correo: "fredyitp@gmail.com",
        }
    },   

    watch:{
      value: function(){
        this.esVisible = this.value
      },
      esVisible: function() {
        this.$emit('cerrar', this.esVisible)
      }  

    },
    
}
</script>
